import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M6 16h13M6 10h13M6 4h13"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "1.5",
      cy: "10",
      r: "1.5",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "1.5",
      cy: "15.5",
      r: "1.5",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }